import { HeaderRight } from '@/App/Layout/HeaderRight'
import { SiderLogo } from '@/App/Layout/SiderLogo'
import { adminclassMentorGraduatesTermAtom, selectedRoleAtom } from '@/store'
import { SelectedRoleEnum } from '@/store/types'
import { getRoleListForHeader } from '@/utils/data'
import { Icon } from '@seiue/ui'
import { useAtom } from 'jotai'
import { $t } from 'packages/locale'
import { FC, useContext } from 'react'
import styled, { useTheme } from 'styled-components'

import { useSemesterInfo } from '../../utils/hooks'
import { selectedRoleToLabel } from '../../utils/utils'
import { GatewayContext } from '../context'

import { Flex } from './Styled'

/**
 * 前台首页 header
 *
 * @param props - 参数
 * @param props.headerRight - header 右侧
 * @returns component
 */
export const GatewayLayoutHeader: FC<{
  headerRight?: React.ReactNode
}> = ({ headerRight }) => {
  const { setModule, module, perms } = useContext(GatewayContext)

  const [selectedRole, setSelectedRole] = useAtom(selectedRoleAtom)
  const [adminclassMentorgraduatesTerm, setAdminclassMentorgraduatesTerm] =
    useAtom(adminclassMentorGraduatesTermAtom)

  const theme = useTheme()

  const { semesterInfo } = useSemesterInfo()

  const roleList = getRoleListForHeader(semesterInfo)

  const displayLabel = selectedRole
    ? selectedRole === SelectedRoleEnum.AdminclassMentor
      ? `行政班`
      : selectedRoleToLabel.get(selectedRole)
    : '范围'

  return (
    <Header>
      <SiderLogo />
      <Flex>
        {headerRight}
        <HeaderRight
          setShowIndex={(val) => {
            if (val) {
              setModule('index')
            } else {
              setModule('account-manage')
            }
          }}
          showIndex={module === 'index'}
          perms={perms}
          isForeground={true}
          selectedKeys={[displayLabel]}
          extraItems={
            roleList.length > 1
              ? [
                  {
                    label: displayLabel,
                    extra: (
                      <Flex>
                        <TipLabel>{$t('切换范围')}</TipLabel>
                      </Flex>
                    ),
                    menus: roleList.map((item) => ({
                      ...item,
                      render: ({ label }) => {
                        const selected =
                          selectedRole === SelectedRoleEnum.AdminclassMentor
                            ? item.key ===
                              `${SelectedRoleEnum.AdminclassMentor}-${adminclassMentorgraduatesTerm}`
                            : selectedRole === item.key

                        return (
                          <ExtraItem
                            $selected={selected}
                            onClick={() => {
                              if (item.isAdminclassMentor) {
                                setSelectedRole(
                                  SelectedRoleEnum.AdminclassMentor
                                )
                                setAdminclassMentorgraduatesTerm(
                                  item.graduatesInTermName
                                )
                              } else {
                                setSelectedRole(item.key as SelectedRoleEnum)
                                setAdminclassMentorgraduatesTerm(undefined)
                              }
                            }}
                          >
                            {label}
                            {selected ? (
                              <Icon
                                icon="SolidRight"
                                color={theme.brand._1}
                              />
                            ) : null}
                          </ExtraItem>
                        )
                      },
                    })),
                  },
                ]
              : []
          }
        />
      </Flex>
    </Header>
  )
}

const Header = styled.div`
  position: relative;
  height: 64px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: #ffffff;
  flex-shrink: 0;
  width: 100%;
  min-width: 1032px;
  box-shadow: 0px 3px 8px -1px rgba(21, 29, 41, 0.04);
`

const TipLabel = styled.span`
  font-size: 12px;
  line-height: 20px;
  color: ${(props) => props.theme.text._3};
`

const ExtraItem = styled.div<{ $selected?: boolean }>`
  padding: 7px 12px;
  font-size: 14px;
  line-height: 22px;
  height: 36px;
  color: ${({ theme, $selected }) =>
    $selected ? theme.brand._1 : theme.text._1};
  min-width: 120px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
`
